import { useActor } from '@xstate/react';

import { LocationLostModal, SelectedChoiceLostModal } from '~src/category/category-lost-modal';
import { CommonModal } from '~src/commons/components/common-modal';
import { GeneralError } from '~src/commons/components/general-error';
import { useTranslations } from '~src/commons/utils/translations/translate';

import { useRecipientFormFlow } from '../context/use-recipient-form-flow';

interface ErrorModalFSMProps {
  onClose: () => void;
}

export const ErrorModalFSM: React.FC<ErrorModalFSMProps> = ({ onClose }) => {
  const { tICU } = useTranslations();
  const { recipientFlowService } = useRecipientFormFlow();
  const [state] = useActor(recipientFlowService);

  switch (true) {
    case state.matches('modal.errorModal.categoryLost'):
      return <SelectedChoiceLostModal onClose={onClose} />;
    case state.matches('modal.errorModal.locationLost'):
      <LocationLostModal onClose={onClose} />;
    case state.matches('modal.errorModal.invalidPostalCode'):
      return (
        <CommonModal
          title={tICU('widget.INVALID_POSTAL_CODE_MODAL.TITLE')}
          body={tICU('widget.INVALID_POSTAL_CODE_MODAL.TEXT')}
          primaryButtonText={tICU('widget.GENERAL_ERROR_MESSAGE.CONFIRMATION_BTN')}
          onPrimaryButtonClick={onClose}
          onClose={onClose}
        />
      );
    case state.matches('modal.errorModal.noShippingOptions'):
      return (
        <CommonModal
          title={tICU('widget.error_modal.NO_OPTIONS_FOUND_FOR_ADDRESS.TITLE')}
          body={tICU('widget.error_modal.NO_OPTIONS_FOUND_FOR_ADDRESS.DESCRIPTION')}
          primaryButtonText={tICU('widget.GENERAL_ERROR_MESSAGE.CONFIRMATION_BTN')}
          onPrimaryButtonClick={onClose}
          onClose={onClose}
        />
      );
    case state.matches('modal.errorModal.noOptionsForAddress'):
      return (
        <CommonModal
          title={tICU('widget.error_modal.NO_OPTIONS_FOUND_FOR_ADDRESS.TITLE')}
          body={tICU('widget.error_modal.NO_OPTIONS_FOUND_FOR_ADDRESS.DESCRIPTION')}
          primaryButtonText={tICU('widget.GENERAL_ERROR_MESSAGE.CONFIRMATION_BTN')}
          onPrimaryButtonClick={onClose}
          onClose={onClose}
        />
      );
    case state.matches('modal.errorModal.generalError'):
    default:
      return <GeneralError error={state.context.errorMessage} onClose={onClose} />;
  }
};
